import { AdminCustomerListItem } from '@models/resources/admin-customer.model';

/**
 * Kundenliste aus Staff-Sicht (Sprint 3, Story S3-2; Sprint 6 S6-11 um
 * `activation_status` erweitert; Sprint-8-Polish um vollständige
 * Stammdaten (phone, company, address_street/zip/city/country, notes)
 * erweitert, damit das Detail-Panel im Dummy-Mode den Bearbeitungs-Pfad
 * zeigen kann; Sprint 8 Sell-Workflow um iban/bic erweitert — Pre-
 * Condition für `sold → paid_out` ist `customer.iban !== null`).
 *
 * Mix aus 6 Einträgen: 4× aktiv (verschiedene Portfolio-Größen),
 * 1× pending (Activation-Mail in den letzten 24 h gesendet), 1× expired
 * (Token abgelaufen, Re-Send nötig). Realistische AT-IBAN/BIC bei den
 * aktiven Customern, null bei den pre-Activation-Stubs.
 */
export const DEMO_ADMIN_CUSTOMERS: AdminCustomerListItem[] = [
  {
    id: 1,
    first_name: 'Maximilian',
    last_name: 'Holzner',
    email: 'customer@goldapp.local',
    depot_number: 'GS-2024-00127',
    portfolio_value_net_eur: 412_835.4,
    customer_since: '2024-03-12',
    is_active: true,
    activation_status: 'active',
    phone: '+43 660 1234567',
    company: null,
    address_street: 'Sonnenallee 12',
    address_zip: '1030',
    address_city: 'Wien',
    address_country: 'AT',
    iban: 'AT611904300234573201',
    bic: 'BKAUATWW',
    notes: 'Erstkunde, persönliche Beratung über Maklerin Eva Schmid.',
  },
  {
    id: 2,
    first_name: 'Elena',
    last_name: 'Weinberger',
    email: 'elena.weinberger@example.at',
    depot_number: 'GS-2023-00098',
    portfolio_value_net_eur: 1_102_004.2,
    customer_since: '2023-06-21',
    is_active: true,
    activation_status: 'active',
    phone: '+43 1 5556677',
    company: 'Weinberger Privatstiftung',
    address_street: 'Operngasse 4',
    address_zip: '1010',
    address_city: 'Wien',
    address_country: 'AT',
    iban: 'AT483200000012345864',
    bic: 'RLNWATWW',
    notes: null,
  },
  {
    id: 3,
    first_name: 'Johannes',
    last_name: 'Gasteiger',
    email: 'j.gasteiger@example.at',
    depot_number: 'GS-2024-00153',
    portfolio_value_net_eur: 58_410.0,
    customer_since: '2024-09-04',
    is_active: true,
    activation_status: 'active',
    phone: null,
    company: null,
    address_street: 'Praterstraße 88',
    address_zip: '1020',
    address_city: 'Wien',
    address_country: 'AT',
    iban: 'AT022050302101023600',
    bic: 'SPIHAT22XXX',
    notes: null,
  },
  {
    id: 4,
    first_name: 'Sabine',
    last_name: 'Klug',
    email: 'sabine.klug@example.com',
    depot_number: 'GS-2022-00041',
    portfolio_value_net_eur: 742_188.7,
    customer_since: '2022-11-02',
    is_active: true,
    activation_status: 'active',
    phone: '+43 664 7890123',
    company: 'Klug Consulting OG',
    address_street: 'Marxergasse 4',
    address_zip: '1030',
    address_city: 'Wien',
    address_country: 'AT',
    iban: 'AT121200012345678901',
    bic: 'BKAUATWW',
    notes: 'Bevorzugt Telefon-Kontakt am Vormittag.',
  },
  {
    id: 5,
    first_name: 'Thomas',
    last_name: 'Berger',
    email: 't.berger@example.at',
    depot_number: 'GS-2025-00012',
    portfolio_value_net_eur: 0,
    customer_since: '2026-05-12',
    is_active: false,
    activation_status: 'pending',
    phone: null,
    company: null,
    address_street: null,
    address_zip: null,
    address_city: null,
    address_country: null,
    iban: null,
    bic: null,
    notes: null,
  },
  {
    id: 6,
    first_name: 'Ulrich',
    last_name: 'Mayrhofer',
    email: 'u.mayrhofer@example.at',
    depot_number: 'GS-2021-00008',
    portfolio_value_net_eur: 234_900.0,
    customer_since: '2021-02-14',
    is_active: false,
    activation_status: 'expired',
    phone: '+43 1 9988776',
    company: null,
    address_street: 'Lerchenfelder Gürtel 21',
    address_zip: '1160',
    address_city: 'Wien',
    address_country: 'AT',
    iban: null,
    bic: null,
    notes: 'Aktivierungs-Mail seit 3 Monaten unbeantwortet — manuelle Nachverfolgung.',
  },
];
